import type { AiKnowledgeCollection } from '@livechat/shared';

type Collection = Pick<AiKnowledgeCollection, 'id' | 'name'>;

function nameSlug(name: string): string {
	return (
		name
			.normalize('NFKD')
			.replace(/[\u0300-\u036f]/g, '')
			.toLowerCase()
			.replace(/[^a-z0-9]+/g, '-')
			.replace(/^-|-$/g, '') || 'collection'
	);
}

export function knowledgeCollectionSlug(collection: Collection, collections: Collection[]): string {
	const slug = nameSlug(collection.name);
	return slug === 'new' || collections.filter((item) => nameSlug(item.name) === slug).length > 1
		? `${slug}--${collection.id}`
		: slug;
}

export function resolveKnowledgeCollection(
	slug: string | undefined,
	collections: Collection[],
): string | undefined {
	if (!slug || slug === 'new') return undefined;
	const separator = slug.indexOf('--');
	if (separator !== -1) {
		const id = slug.slice(separator + 2);
		return collections.find((item) => item.id === id)?.id;
	}
	const matches = collections.filter((item) => nameSlug(item.name) === slug);
	return matches.length === 1 ? matches[0]!.id : undefined;
}
